import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var GradeIds = /*#__PURE__*/function () {
  function GradeIds() {
    _classCallCheck(this, GradeIds);
  }

  _createClass(GradeIds, null, [{
    key: "isValid",
    value: function isValid(value) {
      return value.length <= this.maxLength;
    }
  }]);

  return GradeIds;
}();

_defineProperty(GradeIds, "maxLength", 3);